<template>
  <div class="config_main_manage_background">
    <!-- 设置页面的内容区域 -->
    <div class="config_main_manage_page_wraper">
      <div class="config_main_manage_page_content">
        <!-- 设置页面收藏区域的内容区域样式   以上部分都是公共样式 -->

        <config-input-row v-if="$route.query.type == 'setGateway'">
          <img slot="config_hang_input_img" src="~assets/img/config/weiyima2.png" alt />
          <!-- 只允许输入数字 -->
          <input slot="config_hang_input_left" type="text" v-model="query.address" placeholder="请输入地址(范围:2-254)"
            onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')" />
        </config-input-row>

        <config-input-row v-if="$route.query.type == 'add'
          || $route.query.type == 'onLinechangeAddress'
          || $route.query.type == 'offLinechangeAddress'
          || $route.query.type === 'onLinereplace'
          || $route.query.type === 'offLinereplace'">
          <img slot="config_hang_input_img" src="~assets/img/config/weiyima2.png" alt />
          <!-- 只允许输入数字 -->
          <input slot="config_hang_input_left" type="text" v-model="query.address" placeholder="请输入新设备地址(范围：1-60)"
            onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')"
            :disabled="$route.query.type === 'onLinereplace' || $route.query.type === 'offLinereplace'" />
        </config-input-row>


        <config-input-row v-if="$route.query.type == 'add'
          || $route.query.type == 'onLinechangeRemark' || $route.query.type == 'offLinechangeRemark'">
          <img slot="config_hang_input_img" src="~assets/img/config/hostname.png" alt />
          <input class="add_device_input" slot="config_hang_input_left" type="text" v-model="query.remark"
            placeholder="请输入设备备注" />
        </config-input-row>

        <div v-if="$route.query.type === 'setGateway' || $route.query.type === 'add'" class="xiaotishi_style">
          小提示:当前页面会自动生成一个可用地址,建议优先使用此地址.
        </div>

        <div v-if="$route.query.type === 'setGateway'" class="xiaotishi_style">
          注意:添加主机时,已自动分配地址,一般无需操作此项配置.
        </div>
        <div v-if="$route.query.type === 'setGateway'" class="xiaotishi_style">
          主机地址设置条件:[1,当前主机在线,且主机下无产品(若主机下已绑定产品,则只能使用原地址).2,新设置的主机地址当前用户下唯一,范围(2-254).]
        </div>

        <div v-if="$route.query.type === 'setGateway'" class="public_config_que_ren_btn"
          @click="setGatewayAddressReturnBtnHandle">
          确认设置
        </div>

        <div v-if="$route.query.type != 'setGateway' && $route.query.type != 'add'" class="xiaotishi_style">
          产品类型码:{{ query.productCode }}</div>
        <div v-if="$route.query.type != 'setGateway' && $route.query.type != 'add'" class="xiaotishi_style">
          产品信息码:{{ query.program }}</div>
        <div v-if="$route.query.type != 'setGateway' && $route.query.type != 'add'" class="xiaotishi_style">
          当前地址:[{{ query.borderAddress }}|{{ query.borderInnerAddress }}|{{ query.realAddress }}]</div>

        <div v-if="$route.query.type === 'onLinechangeAddress' || $route.query.type === 'offLinechangeAddress'"
          class="xiaotishi_style">
          小提示:非专业人士并不建议进行此项操作！</div>
        <div v-if="$route.query.type === 'onLinechangeAddress' || $route.query.type === 'offLinechangeAddress'"
          class="xiaotishi_style">
          修改设备地址条件:[1,当前设备在线.2,新修改的设备地址是唯一的.]
        </div>
        <div v-if="$route.query.type === 'onLinechangeAddress' || $route.query.type === 'offLinechangeAddress'"
          class="xiaotishi_style">
          修改设备成功后,将会使原有设备的实际地址发生改变,可能会导致一些功能配置出错（如关联场景,按键等）,需手动更新设备相关联的配置信息.
        </div>
        <div v-if="$route.query.type === 'onLinechangeAddress' || $route.query.type === 'offLinechangeAddress'"
          class="public_config_que_ren_btn" @click="ChangeDeviceAddressReturnBtnHandle">确认修改(不建议进行此操作)</div>
        <div v-if="$route.query.type === 'onLinechangeRemark' || $route.query.type === 'offLinechangeRemark'"
          class="public_config_que_ren_btn" @click="ChangeDeviceRemarkReturnBtnHandle">确认修改</div>



        <div v-if="$route.query.type === 'add'" class="xiaotishi_style">
          小提示：1，先按下需添加设备的编程按钮，使设备处于编程状态。（编程状态：设备提示灯闪烁。）2，再点击确认添加按钮。</div>
        <!-- <div class="xiaotishi_style"></div> -->
        <div v-if="$route.query.type === 'add'" class="xiaotishi_style">需要注意：在添加设备过程中，应保证只有一个设备处于编程状态以及设备地址不重复。</div>

        <div v-if="$route.query.type === 'add'" class="public_config_que_ren_btn"
          @click="add485NewDeviceReturnBtnHandle">确认添加
        </div>


        <!-- ////////////////////////////////////////////// -->


        <div v-if="$route.query.type === 'onLinereplace' || $route.query.type === 'offLinereplace'"
          class="xiaotishi_style">
          替换设备:需确保 [1，准备替换的新设备处于编程状态。2，老设备与新设备的型号完全一致。3，设备地址信息无改动。4，只有一个设备处于编程状态。]
          替换成功后，需手动更新设备相关联的配置信息。</div>



        <div v-if="$route.query.type === 'onLinereplace' || $route.query.type === 'offLinereplace'"
          class="public_config_que_ren_btn" @click="replaceBtnHandle">替换设备(不建议进行此操作)</div>
      </div>
    </div>
  </div>
</template>
<script>
import ConfigInputRow from '@/components/common/config/config-input-row';
// import topNav from "components/common/topnav/topnav";
// import topNavItem from "components/common/topnav/topnavitem";
import configTitleHang from "components/common/config/config-title-hang";

import configHang from "components/common/config/config-hang";

export default {
  data() {
    return {
      oneHostDeviceListData: {
        ////服务器请求到的主机下面的设备列表
        offLineList: [],
        onLineList: []
      },
      oneHostData: {
        ////一个主机的信息
      },
      //代号20220319-1
      query: this.$route.query,

    };
  },
  components: {
    ConfigInputRow,
    // topNav,
    // topNavItem,
    configHang,
    configTitleHang
  },
  methods: {
    // jieBangHostBtnHandle() {
    //   ///解绑主机按钮被点击了
    //   /// 解绑网关接口
    //   // console.log(this.$route.query)
    //   // this.$showTipsToast(9, this.serveHostData);
    // },

    setGatewayAddressReturnBtnHandle() {
      ////保存并返回按钮被点击了
      // console.log(this.$route.query)
      //处理一下入参
      if (this.query.address === "" || this.query.address <= 1 || this.query.address >= 255) {
        this.$toast("地址范围2-254!");
        return;
      }

      //设置主机地址(thread 主机)
      this.$request({
        method: "post",
        url: "/gateway/updateGatewayAddress",
        data: {
          token: this.$store.state.token,
          gatewayId: this.oneHostData.gatewayId,
          borderAddress: this.query.address
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了,
            return;
          } else {
            ////、控制成功了
            // this.serveHostData = res.data.data; ////拿到服务器返回的数据结果
            this.oneHostData.borderAddress = this.query.address;
            this.$store.dispatch("asyUpdataoneHostData", this.oneHostData); ///异步提交更新一个主机的信息到仓库
            this.$router.go(-2);
            this.$showTipsToast(1, "设置成功", true); ////提示框

          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    add485NewDeviceReturnBtnHandle() {
      ////保存并返回按钮被点击了
      // console.log(this.$route.query)
      //处理一下入参
      //处理一下入参
      if (this.query.address === "" || this.query.address <= 0 || this.query.address >= 61) {
        this.$toast("地址范围1-60!");
        return;
      } else if (this.query.remark === "") {
        this.$toast("设备备注不能为空！");
        return;
      } else if (this.query.remark.length > 20) {
        this.$toast("添加失败,名称不能超过20个字符哦~");
        return;
      }
      //兼容老接口 计算实际的地址
      let realAddress = (this.oneHostData.borderAddress * 256) + Number(this.query.address);
      /// 添加产品 接口
      this.$request({
        method: "post",
        url: "/product/saveProduct",
        data: {
          token: this.$store.state.token,

          gatewayId: this.oneHostData.gatewayId,
          address: realAddress,
          remark: this.query.remark
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTipsToast(3, res.data.message);
            ////说明信息填写错误,控制失败了，
            return;
          } else {
            ////、控制成功了
            // this.serveHostData = res.data.data; ////拿到服务器返回的数据结果
            // this.oneHostDeviceListData.onLineList.push

            this.$showTipsToast(1, "添加成功", true); ////提示框
            // this.oneHostDeviceListData.onLineList = res.data.data.onLineList;
            this.$store.dispatch(
              "asyUpdataoneHostDeviceListData",
              res.data.data
            ); ///异步提交信息到仓库
            this.$router.go(-1);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    ChangeDeviceAddressReturnBtnHandle() {
      ////保存修改并返回按钮被点击了
      console.log(this.$route.query)
      //处理一下入参
      if (this.query.address === "" || this.query.address <= 0 || this.query.address >= 61) {
        this.$toast("地址范围1-60!");
        return;
      } else if (this.query.remark === "") {
        this.$toast("设备备注不能为空！");
        return;
      } else if (this.query.remark.length > 20) {
        this.$toast("添加失败,名称不能超过20个字符哦~");
        return;
      }
      if (typeof this.oneHostData == 'undefined' || typeof this.oneHostData.borderAddress == 'undefined') {
        console.log('borderAddress is defined');
        this.$toast("页面数据已被刷新,导致失效,请尝试重新进去该页面~");
        return;
      }

      //兼容老接口 计算实际的地址
      let realAddress = (this.oneHostData.borderAddress * 256) + Number(this.query.address);
      if (realAddress == this.query.realAddress) {
        this.$toast("地址没有改变,无需修改~");
        return;
      }
      console.log(this.query.address);
      console.log(this.oneHostData.borderAddress);
      let productInfo = {
        address: realAddress, //兼容老接口 填入实际的地址
        borderInnerAddress: Number(this.query.address), //新接口增加
        remark: this.query.remark,
        productId: this.query.productId,
        Cindex: this.query.Cindex,
        oneHostDeviceListData: this.oneHostDeviceListData,
        type: this.query.type
      };
      console.log(productInfo);
      this.$showTipsToast(19, productInfo);
    },
    ChangeDeviceRemarkReturnBtnHandle() {
      if (this.query.remark === "") {
        this.$toast("设备备注不能为空！");
        return;
      } else if (this.query.remark.length > 20) {
        this.$toast("添加失败,名称不能超过20个字符哦~");
        return;
      }
      // 修改设备备注或地址--当前为修改备注
      this.$request({
        method: "post",
        url: "/product/updateProductById",
        data: {
          token: this.$store.state.token,
          productId: this.query.productId,
          address: this.query.realAddress,
          remark: this.query.remark
        }
      })
        .then(res => {
          if (res.data.code != 0) {
            this.$showTips1Toast(3, res.data.message);
            ////说明信息填写错误,控制失败了,
            return;
          } else {
            ////、控制成功了
            if (this.query.type == 'onLinechangeRemark') {
              this.oneHostDeviceListData.onLineList[this.query.Cindex].remark = this.query.remark;
            } else if (this.query.type == 'offLinechangeRemark') {
              this.oneHostDeviceListData.offLineList[this.query.Cindex].remark = this.query.remark;
            }
            this.$showTips1Toast(1, "修改成功", true); ////提示框
            //返回两页,与修改地址 逻辑保持一致
            this.$router.go(-2);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    //代号20220319-1
    replaceBtnHandle() {
      //替换设备按钮被按下了
      //处理一下入参
      if (this.query.address === "" || this.query.address <= 0 || this.query.address >= 61) {
        this.$toast("地址范围1-60!");
        return;
      } else if (this.query.remark === "") {
        this.$toast("设备备注不能为空！");
        return;
      } else if (this.query.remark.length > 20) {
        this.$toast("替换失败,名称不能超过20个字符哦~");
        return;
      }
      //兼容老接口 计算实际的地址
      let realAddress = (this.oneHostData.borderAddress * 256) + Number(this.query.address);
      if (realAddress != this.query.realAddress) {
        this.$toast("地址发生改变,替换时不能修改~");
        return;
      }

      let productInfo = {
        address: realAddress, //兼容老接口 填入实际的地址
        borderInnerAddress: Number(this.query.address), //新接口增加
        remark: this.query.remark,
        productId: this.query.productId,
        Cindex: this.query.Cindex,
        oneHostDeviceListData: this.oneHostDeviceListData,
        gatewayId: this.oneHostData.gatewayId,
        type: this.query.type
      };
      this.$showTipsToast(21, productInfo);
    }
  },

  mounted() {
    console.log("mounted阶段");
    console.log(this.$route.query)
  },
  created() {
    console.log("created阶段");
    this.oneHostData = this.$store.state.configinfo.oneHostData; ///拿到仓库当前主机的信息
    this.oneHostDeviceListData = this.$store.state.configinfo.oneHostDeviceListData; ///拿到仓库当前主机下的设备列表
  }
};
</script>

<style>
div .add_device_input {
  /* 聚焦时不切换输入法 */
  ime-mode: auto;
}
</style>